import React, { useEffect } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import RoleManagementColumnModel from './role-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

const RoleManagementPage = (): any => {
  // useEffect(() => {
  //   document.title = "Role Managementt";
  //   },[]);  
  useDocumentTitle();
  return (
    <CommonTablePage
      urlInfoKey={urlKey.Role}
      title="Role Management"
      column={RoleManagementColumnModel.RoleManagementColumn}
    />
  )
}

export default RoleManagementPage
